import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axiosInstance from "Api";
import TransitionOnLoad from "Components/TransitionOnLoad";
import SweetAlert from 'react-bootstrap-sweetalert';
import { toast } from "react-toastify";
import Loader from "react-loaders";

import { Button, Card, CardBody, CardFooter, Col, Row } from "reactstrap";
import SubstitutionDetails from "Pages/Melder/Substitutions/Show/Partials/SubstitutionDetails";
import Chat from "Pages/Melder/Substitutions/Show/Partials/Chat";
import SubstitutionTable from "Pages/Melder/Substitutions/Show/Partials/SubstitutionTable";
import PageHeading from "Layout/AppMain/PageHeading";
import useSWR from "swr";

const Default = (props) => {
    const [chatActive, setChatActive] = useState(true);
    const [subsDateIds, setSubsDateIds] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);
    const [colMdSize, setcolMdSize] = useState(false);

    const params = useParams();
    let navigate = useNavigate();
    const location = useLocation();
    const substitutionId = params.id || '';

    const {
        data: substitutionResponse,
        isLoading: spinner,
        mutate: mutateSubstitution
    } = useSWR(
        substitutionId && !isNaN(substitutionId)
            ? ["request-details", substitutionId]
            : null,
        ([, id]) => {

            return axiosInstance.get(`requests/${id}`);
        }
    );
    useEffect(() => {

        if (substitutionResponse?.data?.error === "invalid_link") {
            navigate("/no-page-found", {
                replace: true,
                state: {
                   previousPath: location.pathname + location.search,
                     errorType: "invalid_link",
                },
            });

        }
    }, [substitutionResponse, navigate]);

    const substitution = substitutionResponse?.data;
    const substitutionComments =
        substitution?.result_info?.comments?.filter(
            msg => msg.vDirComments
        ) || [];

    const changeColMdSize = (value) => {
        setcolMdSize(value);
    }

    const deleteDates = () => {
        setIsDeleted(true);
        axiosInstance
            .post('/requisition/' + substitutionId + '/dates', { ids: subsDateIds })
            .then((response) => {

                if (response.status === 200) {
                    setShowModal(false);
                    setTimeout(() => {
                        mutateSubstitution((current) => {
                            if (!current?.data) return current;

                            return {
                                ...current,
                                data: {
                                    ...current.data,
                                    converted_dayparts: current.data.converted_dayparts
                                        .map(e => {
                                            const dayNdataKeys = Object.entries(e);

                                            const filteredKeys = dayNdataKeys.map(a => {
                                                const dayPartData = Object.entries(a[1]);

                                                if (dayPartData.length <= 2) {
                                                    const data = Object.fromEntries(
                                                        dayPartData.filter(i => {
                                                            return !subsDateIds.includes(
                                                                i[1].iSubsDateId
                                                            );
                                                        })
                                                    );

                                                    return (
                                                        Object.keys(data).length !== 0 && {
                                                            day: dayNdataKeys[0][1],
                                                            data,
                                                        }
                                                    );
                                                }
                                            })[1];

                                            return filteredKeys;
                                        })
                                        .filter(e => typeof e === "object"),
                                },
                            };
                        }, false);
                        setSubsDateIds([]);
                        setIsDeleted(false);
                    }, 950);
                }
            })
            .catch((error) => console.log("catch error:", error));
        toast["success"]("Dagdelen zijn succesvol verwijderd!")
    }


    return (
        <>
            <Fragment>

                <TransitionOnLoad>
                    <div>
                        <div className="chat-layout-wrapper">
                            <div className="app-inner-layout chat-layout" >
                                <div className="app-inner-layout__wrapper">
                                    <Card className="app-inner-layout__content ">
                                        <Row className="mx-0">
                                            <Col md={window.innerWidth < 1500 ? "12" : "10"} sm="12" className="pe-xxl-5">
                                                <SubstitutionDetails substitution={substitution?.result_info} id={substitution?.id} longTermRequests={substitution?.long_term_requests} />
                                                <Card className="main-card mb-3 ">
                                                    <div className="request-list-scroll">
                                                        <CardBody className="p-3 d-flex justify-content-center ">
                                                            {spinner ?
                                                                <Loader type="ball-grid-pulse" />
                                                                :
                                                                substitution?.converted_dayparts?.length ?
                                                                    <SubstitutionTable substitution={substitution} subsDateIds={subsDateIds} setSubsDateIds={setSubsDateIds} isDeleted={isDeleted} />
                                                                    :
                                                                    <div className="fw-bolder">Alle dagdelen uit dit verzoek zijn verwijderd.</div>
                                                            }
                                                        </CardBody>
                                                    </div>
                                                </Card>
                                            </Col>
                                            <Col md={window.innerWidth < 1500 ? "12" : "2"} sm="12">
                                                <div className="chatbox-column-styling">
                                                    <div className="main-melder-chatbox-scroll">
                                                        {chatActive ? <Chat substitutionComments={substitutionComments} substitution={substitution} changeColMdSize={changeColMdSize} mutateSubstitution={mutateSubstitution} /> : null}
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Card>
                                </div>

                            </div>

                            <div className="chat-layout-footer">
                                <CardFooter className="d-block text-center d-flex chat-layout-footer__inner">
                                    <div className="flex-grow-1 d-flex justify-content-start">
                                        <Button onClick={() => navigate(`/verzoeken/${substitutionId}/dagdelen-toevoegen`)} className="d-flex align-items-center btn-color-style mb-2 me-2" size="sm" outline color="primary">
                                            <i className="nav-link-icon pe-7s-plus mt-1 me-2"> </i>
                                            Dagdelen
                                        </Button>
                                        <Button onClick={() => subsDateIds.length !== 0 ? setShowModal(true) : toast["info"]("Selecteer dagdelen.")} className="d-flex align-items-center btn-color-style mb-2 me-2" size="sm" outline color="primary">
                                            <i className="nav-link-icon pe-7s-trash mt-1 me-2"> </i>
                                            Dagdelen
                                        </Button>
                                        <SweetAlert title="Wilt u de geselecteerde dagdelen verwijderen?" show={showModal}
                                            type="warning"
                                            onCancel={() => setShowModal(false)}
                                            onConfirm={() => deleteDates()}
                                            cancelBtnText="Nee"
                                            confirmBtnText="Ja"
                                            showCancel={true}
                                        />
                                    </div>
                                    <div>
                                        <Button size="sm" outline className="me-2 btn-color-style" color="primary" onClick={() => navigate('/verzoeken')}>
                                            <i className="nav-link-icon me-2 pe-7s-back-2" > </i>
                                            Sluiten
                                        </Button>
                                    </div>
                                </CardFooter>
                            </div>

                        </div>
                    </div>
                </TransitionOnLoad>
            </Fragment>


        </>
    )
}


export default Default;
